<template>
    <!--
        作者：luoyiming
        时间：2019-10-25
        描述：加钟信息
    -->
    <div class="pb50">
      <div class="product-content">
        <!--商品信息-->
        <div class="common-form mt16">通话记录</div>
        <div class="table-wrap">
          <el-table size="small" :data="detail.dypLog" border style="width: 100%">
            <el-table-column prop="phone_no" label="技师号码"></el-table-column>
            <el-table-column prop="secret_no" label="隐私号码"></el-table-column>
            <el-table-column prop="peer_no" label="用户号码">
            </el-table-column>
            <el-table-column prop="ring_time" label="被叫响铃时间">
                <template slot-scope="scope">
                <div>{{changeTime(scope.row.ring_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="free_ring_time" label="被叫手机真实响铃时间">
                <template slot-scope="scope">
                <div>{{changeTime(scope.row.free_ring_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="call_type" label="呼叫类型">
                <template slot-scope="scope">
                <div v-if="scope.row.call_type==0">主叫</div>
                <div v-if="scope.row.call_type==1">被叫</div>
                <div v-if="scope.row.call_type==4">呼叫拦截</div>
                
              </template>
            </el-table-column>
            <el-table-column prop="start_time" label="被叫接听时间">
                <template slot-scope="scope">
                <div>{{changeTime(scope.row.start_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="release_time" label="通话释放时间">
                <template slot-scope="scope">
                <div>{{changeTime(scope.row.release_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="call_time" label="主叫拨打时间">
                <template slot-scope="scope">
                <div>{{changeTime(scope.row.call_time)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="call_duration" label="通话时长"></el-table-column>
           
           
          </el-table>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import OrderApi from "@/api/order.js";
  import { deepClone } from "@/utils/base.js";
  export default {
   inject: ["detail"],
    data() {
      return {
        /*是否加载完成*/
        loading: true
        /*订单数据*/
        // detail: {
        // 	product: [],
        // }
      };
    },
    created(e) {
        // console.log(this.detail,'9090')
      /*获取列表*/
      // this.getParams();
    },
    methods: {
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.orderId;
        OrderApi.orderdetail(
          {
            orderId: params
          },
          true
        )
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      changeTime(timestamp){
    
    timestamp = timestamp ? timestamp*1000 : null;
    let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;

      }
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/order/order/part/phonerecord.vue